export class SelectedColor
{
    constructor (
        public color: string,
        public emit: boolean
    )
    {
    }
}
